<template>
  <div class="cs-panel-main">
    <el-row :gutter="16" class="cs-specialities-content">
      <el-col :lg="colOptions.lgSize" :md="colOptions.mdSize" :sm="colOptions.smSize" v-for="(item, index) in specialities.getSpecialitiesByUniversity(dataIn.university)"
        :key="index">
        <el-button round v-ellipsis="item.abbr" @click="onSpecialityClick(item)">
          <span class="el-button__content">{{item.abbr}}</span>
          <span class="el-button__suffix">
            <i class="el-icon-caret-bottom el-icon--right" />
          </span>
        </el-button>
      </el-col>
    </el-row>
    <div v-if="currentCourseList.length > 0" class="cs-courses-content">
      <el-card v-show="!!selectedSpeciality" shadow="always" class="cs-courses-card">
        <el-row>
          <el-col :lg="3" :md="6" :sm="12" v-for="(item, index) in currentCourseList" :key="index">
            <span class="cs-course-name">{{item.name}}</span>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  universities,
  specialities,
  courses,
} from "@/service/studentLanding.service";

export default {
  name: "coursesView",
  props: {
    colOptions: {
      type: Object,
      default: function () {
        return {
          lgSize: 4,
          mdSize: 6,
          smSize: 12,
        };
      },
    },
    dataIn: {
      university: {
        type: Number,
        default: 0,
      },
    },
  },
  data() {
    return {
      selectedSpeciality: 0,
      currentCourseList: [],
    };
  },
  beforeCreate() {
    this.universities = universities;
    this.specialities = specialities;
    this.courses = courses;
  },
  methods: {
    clearSelectedSpeciality() {
      this.selectedSpeciality = 0;
      this.currentCourseList = [];
    },
    onSpecialityClick(specialityItem) {
      let oldSelectSpeciality = this.selectedSpeciality;

      if (!!oldSelectSpeciality && specialityItem.value === oldSelectSpeciality)
        return;

      this.selectedSpeciality = 0;

      this.$nextTick(() => {
        setTimeout(() => {
          this.currentCourseList = this.courses.getCoursesBySpeciality(
            specialityItem.value
          );
          this.selectedSpeciality = specialityItem.value;
        }, 100);
      });
    },
  },
  watch: {
    dataIn(newValue) {
      this.clearSelectedSpeciality();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-panel-main {
  .cs-specialities-content {
    margin: 0;

    .el-col {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .el-button {
      width: 150px;
      height: 40px;
      background: rgb(227, 227, 227);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;

      span {
        color: #006cb4;
      }

      .el-icon--right {
        margin-left: 0;
      }

      .el-button__suffix {
        position: absolute;
        right: 10px;
      }
    }
  }

  .cs-courses-content {
    width: 70%;
    min-height: 64px;
    text-align: center;
    margin: auto;
    margin-top: 44px;
    overflow-y: auto;

    .cs-courses-card {
      margin: auto auto;
      animation: fade-in 1.5s;
      -webkit-animation: fade-in 1.5s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studentLanding/coursesView.vue